import mod from "-!./document.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./document.js?vue&type=script&lang=js&external"